import { gql } from 'urql'

/**
 * Grid practice fields, one fragment per relation type. Spreading the wrong type condition is
 * only caught by the server (PossibleFragmentSpreads), so pick the one matching the relation:
 * `ConsolidatedPractice` (cash deposit / drawer), `ConsolidatedPracticeSummary` (most list
 * relations).
 *
 * Interpolate with urql's `gql` tag, not the `gql(...)` call form — a DocumentNode inside a
 * plain template string stringifies to `[object Object]` and throws at import time.
 */
export const GRID_CONSOLIDATED_PRACTICE_FRAGMENT = gql`
	fragment GridConsolidatedPractice on ConsolidatedPractice {
		id
		name
		consolidatorReferenceCode
		consolidatorReferenceCode2
		consolidatorReferenceCode3
		netsuiteId
		skyworldId
		pimsMetadata
		logoUrl
		paymentId
		lendingId
		industryProgramMetadata
	}
`

/** Grid practice fields available on the `ConsolidatedPracticeSummary` relation type. */
export const GRID_CONSOLIDATED_PRACTICE_SUMMARY_FRAGMENT = gql`
	fragment GridConsolidatedPracticeSummary on ConsolidatedPracticeSummary {
		id
		name
		consolidatorReferenceCode
		consolidatorReferenceCode2
		netsuiteId
		skyworldId
		pimsMetadata
		paymentId
	}
`
